<template>
    <v-container class="pa-4">
        <v-card class="pa-4" outlined>
            <v-row align="center" justify="center">
                <v-avatar size="120">
                    <img :src="fotoPerfilUrl" alt="Foto de perfil" />
                </v-avatar>
            </v-row>
            <v-row align="center" justify="center" class="mt-4">
                <h2 class="text-h5">{{ nombreUsuario }}</h2>
            </v-row>
            <v-row align="center" justify="center" class="mt-2">
                <p class="text-h6">Rol: {{ rolFormateado }}</p>
            </v-row>
            <v-row align="center" justify="center" class="mt-4">
                <v-btn color="primary" class="ma-2" @click="abrirCamara" :loading="guardandoFoto">
                    <v-icon left>mdi-camera</v-icon>
                    Tomar foto con cámara
                </v-btn>
                <v-btn color="primary" class="ma-2" @click="cargarFoto" :loading="guardandoFoto">
                    <v-icon left>mdi-image</v-icon>
                    Cargar foto desde dispositivo
                </v-btn>
                <v-btn color="primary" class="ma-2" @click="cambiarPassword">
                    <v-icon left>mdi-lock</v-icon>
                    Cambiar contraseña
                </v-btn>
            </v-row>
        </v-card>
        <video ref="video" autoplay style="display: none;"></video>
        <canvas ref="canvas" style="display: none;"></canvas>
        
        <!-- Snackbar para mensajes -->
        <v-snackbar
            v-model="mostrarMensaje"
            :timeout="3000"
            :color="mensaje.color"
            top
        >
            {{ mensaje.texto }}
        </v-snackbar>
    </v-container>
</template>
<script>
import FotoPerfilService from '../../Servicios/FotoPerfilService';
import Utiles from '../../Servicios/Utiles';

export default {
    name: "MiPerfil",
    data: () => ({
        idUsuario: localStorage.getItem('idUsuario'),
        nombreUsuario: localStorage.getItem('nombreUsuario'),
        rolUsuario: localStorage.getItem('rolUsuario') || 'Usuario',
        fotoPerfil: null,
        guardandoFoto: false,
        mostrarMensaje: false,
        mensaje: {
            texto: "",
            color: ""
        }
    }),
    
    computed: {
        rolFormateado() {
            switch(this.rolUsuario) {
                case 'admin':
                    return 'Administrador';
                case 'administrador':
                    return 'Administrador';
                case 'usuario':
                    return 'Usuario';
                case 'empleado':
                    return 'Empleado';
                case 'recepcionista':
                    return 'Recepcionista';
                default:
                    return this.rolUsuario ? this.rolUsuario.charAt(0).toUpperCase() + this.rolUsuario.slice(1) : 'Usuario';
            }
        },
        
        fotoPerfilUrl() {
            // Si hay foto en localStorage
            const fotoLocalStorage = localStorage.getItem(`fotoPerfil_${this.idUsuario}`);
            if (fotoLocalStorage && fotoLocalStorage !== 'null' && fotoLocalStorage !== 'undefined') {
                // Si es base64, devolverla directamente
                if (fotoLocalStorage.startsWith('data:image/')) {
                    return fotoLocalStorage;
                }
                // Si es una ruta de archivo
                return Utiles.generarURL(fotoLocalStorage.includes('imagenes/') ? fotoLocalStorage : `imagenes/${fotoLocalStorage}`);
            }
            
            // Usar imagen por defecto
            return Utiles.generarURL('imagenes/usuario.png');
        }
    },
    
    async mounted() {
        await this.cargarFotoPerfil();
    },
    
    methods: {
        async cargarFotoPerfil() {
            try {
                const resultado = await FotoPerfilService.obtenerFotoPerfil(this.idUsuario);
                if (resultado.resultado && resultado.fotoPerfil) {
                    this.fotoPerfil = resultado.fotoPerfil;
                    localStorage.setItem(`fotoPerfil_${this.idUsuario}`, resultado.fotoPerfil);
                }
            } catch (error) {
                console.error('Error al cargar foto de perfil:', error);
            }
        },
        
        async guardarFotoEnBaseDatos(fotoBase64) {
            this.guardandoFoto = true;
            try {
                const resultado = await FotoPerfilService.actualizarFotoPerfil(this.idUsuario, fotoBase64);
                if (resultado.resultado) {
                    this.fotoPerfil = fotoBase64;
                    this.mostrarMensaje = true;
                    this.mensaje = {
                        texto: "Foto de perfil actualizada correctamente",
                        color: "success"
                    };
                } else {
                    this.mostrarMensaje = true;
                    this.mensaje = {
                        texto: "Error al guardar la foto de perfil",
                        color: "error"
                    };
                }
            } catch (error) {
                console.error('Error al guardar foto:', error);
                this.mostrarMensaje = true;
                this.mensaje = {
                    texto: "Error al guardar la foto de perfil",
                    color: "error"
                };
            } finally {
                this.guardandoFoto = false;
            }
        },
        
        cambiarPassword() {
            this.$router.push({ name: 'CambiarPassword' });
        },
        
        abrirCamara() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;

            navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    video.style.display = 'block';
                    video.srcObject = stream;

                    video.addEventListener('click', async () => {
                        const context = canvas.getContext('2d');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        context.drawImage(video, 0, 0, canvas.width, canvas.height);

                        const imageData = canvas.toDataURL('image/png');
                        
                        // Guardar en base de datos
                        await this.guardarFotoEnBaseDatos(imageData);

                        video.style.display = 'none';
                        stream.getTracks().forEach(track => track.stop());
                    });
                })
                .catch((error) => {
                    console.error('Error al acceder a la cámara:', error);
                    this.mostrarMensaje = true;
                    this.mensaje = {
                        texto: "Error al acceder a la cámara",
                        color: "error"
                    };
                });
        },
        
        cargarFoto() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = async (event) => {
                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = async (e) => {
                        const imageData = e.target.result;
                        // Guardar en base de datos
                        await this.guardarFotoEnBaseDatos(imageData);
                    };
                    reader.readAsDataURL(file);
                }
            };
            input.click();
        },
    },
};
</script>
<style>
.v-card {
    border-radius: 12px;
    background-color: #f5f5f5;
}
.v-avatar img {
    object-fit: cover;
    border-radius: 50%;
}
.text-h5 {
    font-weight: bold;
    margin-bottom: 0;
}
.text-h6 {
    margin-top: 0;
    color: #757575;
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/MiPerfil.vue